export const departamentoPadraoEnum = {
    DEPARTAMENTO_PESSOAL: {
        id: 1,
        nome: "Departamento Pessoal"
    },
    CONTABIL: {
        id: 2,
        nome: "Contábil"
    },
    ESCRITA_FISCAL: {
        id: 3,
        nome: "Escrita Fiscal"
    },
    FINANCEIRO: {
        id: 4,
        nome: "Financeiro"
    },
    LEGALIZACAO: {
        id: 5,
        nome: "Legalização"
    }
}